import ProfileForm from 'views/Profile/ProfileForm';
import basicRoutes from './basicRoutes';
import HotelsForm from 'views/Hotels/HotelsForm';
import HotelsIndex from 'views/Hotels/HotelsIndex';
import ReportSalesIndex from 'views/ReportSales/ReportSalesIndex';
import auth from '../lib/auth';

const authUser = auth.getCurrentUser();

let dashboardRoutes = [
  ...basicRoutes,

  {
    collapse: true,
    path: '/config',
    name: 'Configuracion',
    state: 'Configuracion',
    icon: 'pe-7s-box2',
    views: [
      {
        path: '/admin/profile',
        name: 'Perfil',
        icon: 'pe-7s-user',
        component: ProfileForm,
        invisible: false,
      },
    ],
  },

  {
    collapse: true,
    path: '/reports',
    name: 'Informes',
    state: 'Informes',
    icon: 'pe-7s-box2',
    views: [
      {
        path: '/admin/reports/sales',
        name: 'Reportes Ventas',
        icon: 'pe-7s-attention',
        component: ReportSalesIndex,
      },
    ],
  },

  { redirect: true, path: '/', pathTo: '/iniciar-sesion', name: 'Dashboard' },
];

if (authUser && authUser.roles.includes('adminHotel')) {
  const configMenu = dashboardRoutes.find((r) => r.name === 'Configuracion');
  if (configMenu && Array.isArray(configMenu.views)) {
    configMenu.views.unshift(
      {
        path: '/admin/config/hotels/:id',
        name: 'Hoteles',
        component: HotelsForm,
        invisible: true,
      },
      {
        path: '/admin/config/hotels',
        name: 'Hoteles',
        icon: 'pe-7s-map-marker',
        component: HotelsIndex,
        invisible: false,
      }
    );
  }
}

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx